export enum UserState {
  active = 'active',
  deactivated = 'deactivated',
  invited = 'invited',
}
